import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Path } from '../../../routes';

function PrivateRoute({ render, ...rest }) {
  const _token = localStorage.getItem('_token');

  return (
    <Route
      {...rest}
      render={(props) =>
        _token ? (
          render(rest)
        ) : (
          <Redirect
            to={{ pathname: Path.LOGIN, state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
